// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listing_table_patients_name {
  cursor: pointer;
}

.patients_listing_container {
  margin-bottom: 70px;
}

#patients_item {
  text-align: left;
}

#patients_item_age {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/PatientsList/PatientsList.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AACA;EACI,mBAAA;AAEJ;;AAAA;EACI,gBAAA;AAGJ;;AAAA;EACI,kBAAA;AAGJ","sourcesContent":[".listing_table_patients_name {\r\n    cursor: pointer;\r\n}\r\n.patients_listing_container {\r\n    margin-bottom: 70px;\r\n}\r\n#patients_item {\r\n    text-align: left;\r\n}\r\n\r\n#patients_item_age {\r\n    text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
